import { deleteTeamMemberInvitation } from "api/team";
import { useGlobalToast } from "components/GlobalToastProvider";
import { useMutation } from "react-query";

export const useDeleteTeamMemberInvitation = (options = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, ...rest } = useMutation(
    ({ invitationGuid }) => deleteTeamMemberInvitation(invitationGuid),
    {
      onError: (_, variables, context) => {
        showToast({
          message: "Whoops! Something went wrong",
          errorState: true,
          retryHandler: () => mutate(variables, context),
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    deleteTeamMemberInvitationMutation: mutate,
    ...rest,
  };
};
